import { colorData } from '@nice-ccf/ui-controls';
import { CSSProperties } from 'react';
import { styleMap } from './ccf-rich-text-editor.styles';

type CustomStyleMap = Record<string, CSSProperties>;

const colorStyleMap: CustomStyleMap = colorData.reduce(
  (acc, { group, id, property, value }) => ({
    ...acc,
    [`${group}_${id}`]: { [property]: value },
  }),
  {}
);

export const CUSTOM_STYLE_MAP:CustomStyleMap = {...colorStyleMap, ...styleMap}